'use strict';

module.exports = /* @ngInject */ function () {
	return {
		restrict: 'E',
		scope: {
			orderId: '=',
		},
		templateUrl: `./${BUILD_PATH}/link-order.directive.tpl.html`,
		controller: /* @ngInject */ function ($scope, translationService) {
			$scope.openOrderLinkingPopup = openOrderLinkingPopup;
			$scope.checkPopup = checkPopup;

			$scope.popupOpen = true;

			function checkPopup(){
				$scope.popupOpen = window.popupIsOpen();
			}

			/**
			 * opens an dojo popup to create links between orders
			 */
			function openOrderLinkingPopup() {
				if(!$scope.popupOpen){
					const customPopupStyles = 'width: 1000px; height: 60%; max-width: 90%; max-height; 60%;';
					window.openPopup(`angular/order_relation.htm&orderId=${$scope.orderId}`,
						translationService.translate(
							_('Bestellungen verknüpfen')),
						null,
						null,
						customPopupStyles,
						true);
				}
			}
		}
	};
}
